export const environment = {
    production: true,
    API_URL: 'https://api-dev.toppredictor.com/whitelabeling/admin/api',
    SOCCER_CONTEST_MS_API: "https://api-dev.toppredictor.com/contest/api/soccer/contest",
    AWS_ASSETS_URL: 'https://s3.eu-west-1.amazonaws.com/toppredictor.assets/dev-new/',
    PITCH_WRITER_API_URL: 'https://api-dev.toppredictor.com/whitelabeling/admin/api',
    captchaSiteKey: '6Ld6754UAAAAABxI9v-vncc3Tq_tochByGIQj0M3' // :TODO Add staging site key
};
